export var version = '3.7.17';
//# sourceMappingURL=version.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@apollo/client/version.js
// module id = 1537
// module chunks = 4